import types from "resources/types";
import { createResourceDetailQuery } from "queries";

export const newItemsQuery = (config = {}) =>
  createResourceDetailQuery(types.NEW_ITEMS, {
    url: "/api/v2/users/new_items/",
    ...config,
  });
